// src/pages/Dashboard/Admin/Coaching/components/EmptyCoachingState.jsx

import React from "react";
import { FaUserTie } from "react-icons/fa";

export default function EmptyCoachingState() {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-10 text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-[24px] bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
          <FaUserTie />
        </div>

        <h3 className="mt-5 text-lg font-bold text-slate-900 dark:text-white">
          Choisissez un enseignant pour commencer
        </h3>

        <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-slate-600 dark:text-slate-300">
          Les événements coachés, les heures enregistrées et le récapitulatif
          mensuel s’afficheront ici après sélection.
        </p>
      </div>
    </section>
  );
}